export const initialValues = {
  inputValues: {
    uuidTag: '',
    brand: '',
    nip: '',
  },
  required: {
    uuidTag: { required: true },
    brand: { required: true },
    nip: { required: true, exactLength: 4, message: '4 Digitos' },
  }
};